"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var getStateMedianFamilyIncome_1 = __importDefault(require("./getStateMedianFamilyIncome"));

function isBelowMonthlyMedianIncome(income, state, persons) {
  if (!income) throw new Error("Missing Income");
  if (!state) throw new Error("Missing State");
  var medianMonthly = (0, getStateMedianFamilyIncome_1.default)(state, persons) / 12;
  return Number(income) <= Number(medianMonthly);
}

exports.default = isBelowMonthlyMedianIncome;